import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useLoginUMSMutation } from 'services/api/ums';

import { isAuthorizedDomain, isValidEmail } from '../helpers';
import { UMS_ACCOUNT_NAME } from '../constants';
import ForgotPasswordModal from './ForgotPasswordModal';
import RequestAccessModal from './RequestAccessModal';
import { UMSLoginFormStyles } from './style';
import { track } from 'analytics/posthog';

function UMSLoginForm({ onSuccess, onError }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [requestModal, setRequestModal] = useState(false);
  const [passwordModal, setPasswordModal] = useState(false);

  const [login, loginState] = useLoginUMSMutation();

  useEffect(() => {
    if (loginState.isSuccess) {
      onSuccess({
        profileObj: {
          ...loginState.data,
          familyName: loginState.data.lastName,
          givenName: loginState.data.firstName,
          name: `${get(loginState, 'data.firstName', '')} ${get(
            loginState,
            'data.lastName',
            '',
          )}`,
          type: isAuthorizedDomain(loginState.data.email)
            ? 'internal'
            : 'external',
        },
        tokenId: loginState.data.accessToken,
        tokenType: 'UMS',
        umsId: loginState.data.id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginState.isSuccess]);

  useEffect(() => {
    if (loginState.isError) {
      setError(get(loginState, 'error.data.message'));
      track('login failed', {
        login_method: 'UMS',
        error_code_or_message: get(loginState, 'error.data.message'),
        surface: 'login',
      });
      onError(get(loginState, 'error.data.message'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginState.isError]);

  return (
    <UMSLoginFormStyles>
      <Form.Group
        className={
          !email
            ? 'form-group'
            : isValidEmail(email)
              ? 'form-group success'
              : 'form-group error'
        }
      >
        <Form.Label>Email</Form.Label>
        <Form.Control
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
      </Form.Group>
      <Form.Group className={password ? 'form-group success' : 'form-group'}>
        <Form.Label>Password</Form.Label>
        <Form.Control
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
      </Form.Group>
      {error && <div className="error-message">{error}</div>}
      <div className="form-footer">
        <div
          className="forgot-password"
          onClick={() => {
            track('forgot password opened', {
              surface: 'login',
            });
            setPasswordModal(true);
          }}
        >
          Forgot Password ?
        </div>
        <Button
          disabled={
            loginState.isLoading || !email || !password || !isValidEmail(email)
          }
          onClick={() => {
            track('login attempted', {
              login_method: 'UMS',
              surface: 'login',
            });
            login({ email, password, accountName: UMS_ACCOUNT_NAME });
          }}
        >
          Continue
        </Button>
      </div>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a
        className="request-access"
        onClick={() => {
          track('request access opened', {
            surface: 'login',
          });
          setRequestModal(true);
        }}
      >
        Click here to request access
      </a>

      <RequestAccessModal
        show={requestModal}
        onHide={() => setRequestModal(false)}
      />
      <ForgotPasswordModal
        show={passwordModal}
        onHide={() => setPasswordModal(false)}
      />
    </UMSLoginFormStyles>
  );
}

export default UMSLoginForm;
